<template>
    <vue-final-modal
        name="auth-certificate-modal"
        class="verification-number-modal modal-common change pa50"
        :width="'600px'"
        :height="'auto'"
        @before-open="handlerBeforeOpen"
        @before-close="handlerBeforeClose"
        v-model="show"
        :clickToClose="false"
    >
        <div class="modal-content-common popup-modal" v-if="show">
            <div class="box-input-term">
                <div class="title-input ta-center">본인인증 유효기간이 만료되었거나<br>본인인증을 하지 않으셨어요!<br><br>레인보우TV 서비스를 이용하려면<br>본인인증이
                    필요해요!
                </div>
            </div>
            <button class="btn-common mt15 square w100p" @click="runAuthenticatio()">인증하기</button>
            <form name="form_chk" method="post" action="https://nice.checkplus.co.kr/CheckPlusSafeModel/service.cb">
                <input type="hidden" id="m" name="m" value="service"/>
                <input type="hidden" id="token_version_id" name="token_version_id" value=""/>
                <input type="hidden" id="enc_data" name="enc_data" value=""/>
                <input type="hidden" id="integrity_value" name="integrity_value" value=""/>
            </form>
        </div>
    </vue-final-modal>
</template>

<script>

import EventBus from "@/utils/event-bus";
import util from "@/mixins/util";

export default {
    name: "AuthCertificateModal",
    mixins: [],
    components: {},
    inject: [],
    provide() {
        return {}
    },
    props: {},
    data() {
        return {
            show: false,
        }
    },
    beforeRouterEnter() {
    },
    created() {
    },
    mounted() {
    },
    beforeUnmount() {
    },
    unmounted() {
    },
    computed: {},
    methods: {
        handlerBeforeOpen(event) {
        },

        handlerBeforeClose() {
            this.createAlert({
                content: `본인인증이 완료되었어요!\n(인증일 : ${Date.now})`,
                back: () => {

                }
            })
        },
        backEvent() {
            this.$vfm.hide('auth-certificate-modal');
        },
        runAuthenticatio() {
            this.$localStorage.remove('AuthenticationObj')
            this.$localStorage.remove('enc_data')
            const currentUrl = window.location.origin;
            let params = {
                returnUrl: currentUrl + '/certified/first/result'
            }
            EventBus.$emit('apiLoading', true);
            this.$api.$pass.getEncryptData(params).then(res => {
                if (res.code !== 1) {
                    this.errorAlert('본인인증에 실패하였습니다.');
                    return false;
                }
                this.encodeData = res.result.data;
                setTimeout(() => {
                    this.checkIdentity();
                    EventBus.$emit('apiLoading', false);
                }, 500)
            })
        },
        checkIdentity() {
            try {
                let token_version_id = this.encodeData.tokenVersionId;
                let enc_data = this.encodeData.encData;
                let integrity_value = this.encodeData.integrityValue;

                document.form_chk.action = "https://nice.checkplus.co.kr/CheckPlusSafeModel/service.cb";
                document.form_chk.token_version_id.value = token_version_id;
                document.form_chk.enc_data.value = enc_data;
                document.form_chk.integrity_value.value = integrity_value;

                let obj = {
                    key: this.encodeData.key,
                    iv: this.encodeData.iv,
                }
                let decodeObj = btoa(JSON.stringify(obj));
                this.$localStorage.set('AuthenticationObj', decodeObj)
                this.$localStorage.set('loginRoute', this.$route.path);
                let result = window.open('', 'popupChk', 'menubar=no, status=no, toolbar=no, location=no, scrollbar=no');

                if (!util.isEmpty(result)) {
                    result.focus();
                } else {
                    this.errorAlert('팝업차단을 허용해주시기 바랍니다.');
                }
                document.form_chk.target = "popupChk";
                document.form_chk.submit();
            } catch (e) {
                console.log(e);
            }
        },
    },
    watch: {},
}
</script>

<style scoped>

</style>
